import type { ScheduledDetailedCopy } from './scheduled-page-copy-translations';

export const scheduledDetailedCopyVietnamese = {
  vi: {
    status: {
      upcoming: 'Sắp tới',
      running: 'Đang chạy',
      waitingBackground: 'Đang chờ tác vụ nền',
      succeeded: 'Thành công',
      failed: 'Thất bại',
      skipped: 'Đã bỏ qua',
      needsAttention: 'Cần chú ý',
      unknownOutcome: 'Kết quả chưa rõ',
      canceled: 'Đã hủy',
      malformed: 'Không khả dụng',
      paused: 'Đã tạm dừng',
    },
    editor: {
      createTitle: 'Lịch mới',
      editTitle: 'Chỉnh sửa lịch',
      description:
        'Thiết lập tác vụ, thời gian, ngữ cảnh và quyền chạy không giám sát.',
      stepOf: 'Bước {step} trên 4',
      task: 'Tác vụ',
      timing: 'Thời gian',
      execution: 'Thực thi',
      review: 'Xem lại',
      name: 'Tên lịch',
      namePlaceholder: 'ví dụ: tóm tắt hiệu suất thứ Hai',
      instructions: 'Hướng dẫn cho tác nhân',
      instructionsPlaceholder:
        'Mô tả kết quả tác nhân cần tạo và nơi tác nhân được phép hành động.',
      sourceChat: 'Cuộc trò chuyện nguồn',
      scheduleThisChat: 'Lên lịch cuộc trò chuyện này',
      sourceSnapshot:
        'Một bản chụp riêng tư được lưu khi bạn tạo lịch. Thay đổi trò chuyện sau đó sẽ không làm đổi lịch này.',
      sourceUnavailable:
        'Cuộc trò chuyện nguồn không khả dụng hoặc bạn không còn quyền truy cập.',
      sourceChatLockedNote:
        'Lịch biểu dùng lại cuộc trò chuyện nguồn phải giữ ngữ cảnh liên tục và chế độ hiển thị riêng tư.',
      recurrence: 'Lặp lại',
      once: 'Một lần',
      hourly: 'Mỗi giờ',
      daily: 'Hằng ngày',
      weekdays: 'Ngày làm việc',
      selectedWeekdays: 'Các ngày đã chọn trong tuần',
      weekly: 'Hằng tuần',
      monthly: 'Hằng tháng',
      date: 'Ngày',
      time: 'Giờ địa phương',
      dayOfMonth: 'Ngày trong tháng',
      whenPlaceholder: 'Ngày mai',
      whenInvalid: 'Nhập ngày, ví dụ “ngày mai”.',
      end: 'Kết thúc',
      never: 'Không bao giờ',
      onDate: 'Vào một ngày',
      afterOccurrences: 'Sau một số lần chạy',
      occurrences: 'Lần chạy',
      nextRuns: 'Các lần chạy tiếp theo',
      schedulePreview: 'Xem trước lịch',
      noEndDate: 'Không có ngày kết thúc.',
      runsUntil: 'Chạy đến {date}.',
      totalRuns: 'Tổng cộng {count} lần chạy.',
      resolvingTime: 'Máy chủ đang kiểm tra giờ địa phương này…',
      serverTimeRequired:
        'Máy chủ phải xác nhận giờ địa phương này trước khi lưu.',
      contextMode: 'Ngữ cảnh trò chuyện',
      persistent: 'Ngữ cảnh liên tục',
      persistentDescription:
        'Dùng lại một cuộc trò chuyện thuộc lịch cho mọi lần chạy.',
      isolated: 'Cuộc trò chuyện mới cho mỗi lần chạy',
      isolatedDescription: 'Bắt đầu mỗi lần chạy với ngữ cảnh riêng biệt.',
      visibility: 'Khả năng hiển thị',
      private: 'Riêng tư',
      privateDescription:
        'Chỉ bạn có thể xem toàn bộ yêu cầu, cuộc trò chuyện, hoạt động công cụ và kết quả.',
      workspace: 'Không gian làm việc',
      workspaceWarning:
        'Chia sẻ với không gian làm việc sẽ hiển thị toàn bộ yêu cầu, cuộc trò chuyện, hoạt động công cụ và kết quả.',
      creditPolicy: 'Chính sách tín dụng của không gian làm việc',
      creditsAvailable:
        'Các lần chạy sử dụng số dư tín dụng và giới hạn hiện có của không gian làm việc.',
      creditsUnavailable:
        'Không gian làm việc hiện không có tín dụng khả dụng. Lịch có thể bị tạm dừng khi chạy.',
      fullAuthorityTitle: 'Hành động của tác nhân',
      fullAuthorityDescription:
        'Mỗi lần chạy dùng quyền truy cập hiện tại của bạn và có thể thực hiện bất kỳ hành động nào, kể cả xóa hoặc thay đổi nội dung, mà không hỏi bạn trước. Mỗi lần chạy có thể dùng tín dụng.',
      authorityAcknowledgment: 'Cho phép mọi hành động mà không cần hỏi trước.',
      authorityRequired:
        'Cho phép hành động của tác nhân để tạo lịch này. Các lần chạy diễn ra tự động nên sau đó không ai có thể phê duyệt.',
      recurrenceUnresolved:
        'Không thể xác nhận thời điểm chạy này. Vui lòng chọn lại ngày và giờ.',
      notifications: 'Thông báo trong ứng dụng',
      notificationsDescription:
        'Bạn sẽ nhận một thông báo cho mỗi kết quả cuối cùng cần chú ý.',
      reviewSummary: 'Xem kỹ tác vụ và tần suất trước khi tạo lịch.',
      required: 'Trường này là bắt buộc.',
      invalid: 'Nhập một giá trị hợp lệ.',
      past: 'Hãy chọn thời điểm trong tương lai.',
      endBeforeStart: 'Kết thúc lịch sau lần chạy đầu tiên.',
      draftRestored: 'Đã khôi phục bản nháp chưa lưu của bạn.',
      tooLong: 'Giá trị này quá dài.',
      createDisabled:
        'Bạn không có quyền tạo lịch trong không gian làm việc này.',
      saved: 'Đã lưu lịch',
      unsavedTitle: 'Bỏ các thay đổi chưa lưu?',
      unsavedDescription:
        'Các thay đổi của lịch này sẽ bị mất nếu bạn đóng ngay bây giờ.',
      discardChanges: 'Bỏ thay đổi',
    },
    detail: {
      title: 'Chi tiết lịch',
      cadence: 'Tần suất',
      owner: 'Chủ sở hữu',
      timezone: 'Múi giờ',
      nextRun: 'Lần chạy tiếp theo',
      lastRun: 'Lần chạy gần nhất',
      prompt: 'Yêu cầu đầy đủ',
      sourceContext: 'Ngữ cảnh nguồn đã lưu',
      executionMode: 'Chế độ thực thi',
      recentUsage: 'Mức dùng gần đây',
      credits: 'tín dụng',
      tools: 'hành động',
      history: 'Lịch sử chạy',
      transcript: 'Cuộc trò chuyện',
      resultFiles: 'Tệp kết quả',
      noResultFiles: 'Không có tệp kết quả nào được ghi nhận cho lần chạy này.',
      noRuns: 'Chưa có lần chạy nào.',
      noTranscript: 'Chưa có cuộc trò chuyện cho lần chạy này.',
      toolActivity: 'Hoạt động',
      toolInput: 'Chi tiết tác vụ',
      toolResult: 'Kết quả',
      noToolActivity: 'Không có hoạt động cho lần chạy này.',
      loadMore: 'Tải thêm',
      preview: 'Xem trước',
      sourceScheduled: 'Theo lịch',
      sourceManual: 'Theo yêu cầu',
      sourceWatchdog: 'Khôi phục',
      roleUser: 'Người dùng',
      roleAssistant: 'Trợ lý',
      roleTool: 'Công cụ',
      roleSystem: 'Hệ thống',
      runNow: 'Chạy ngay',
      pause: 'Tạm dừng',
      resume: 'Tiếp tục',
      share: 'Chia sẻ với không gian làm việc',
      unshare: 'Chuyển thành riêng tư',
      cancelRun: 'Hủy lần chạy đang hoạt động',
      archive: 'Lưu trữ',
      deleteSchedule: 'Xóa lịch',
      openThread: 'Xem cuộc trò chuyện',
      confirmArchive: 'Lưu trữ lịch này?',
      confirmArchiveDescription:
        'Công việc tương lai sẽ bị hủy. Lịch sử và bản ghi kiểm toán vẫn được giữ lại.',
      confirmDelete: 'Xóa lịch này?',
      confirmDeleteDescription:
        'Lịch này sẽ bị xóa vĩnh viễn. Các cuộc trò chuyện trước đây và nội dung đã tạo vẫn ở trong không gian làm việc.',
      confirmUnshareDescription:
        'Thành viên không gian làm việc sẽ mất ngay quyền truy cập vào lời nhắc, bản ghi, hoạt động công cụ và kết quả.',
      confirmCancel: 'Hủy lần chạy đang hoạt động?',
      confirmCancelDescription:
        'Lần chạy sẽ dừng tại điểm hủy an toàn tiếp theo.',
      actionCompleted: 'Đã cập nhật lịch',
      permissionDenied:
        'Bạn có thể xem lịch này, nhưng chỉ chủ sở hữu hoặc quản trị viên lịch mới có thể thay đổi.',
      needsAttention:
        'Lần chạy này cần được xem lại trước khi tiếp tục công việc không giám sát.',
      runDetails: 'Chi tiết lần chạy',
    },
    notifications: {
      completed: 'Lần chạy theo lịch đã hoàn tất',
      failed: 'Lần chạy theo lịch đã thất bại',
      attention: 'Lần chạy theo lịch cần chú ý',
      missed: 'Đã lỡ lần chạy một lần theo lịch',
      viewRun: 'Xem lần chạy',
      empty: 'Chưa có thông báo lượt chạy.',
      unread: 'Chưa đọc',
      read: 'Đã đọc',
      caughtUp: 'Bạn đã xem tất cả thông báo.',
    },
    errors: {
      generic: 'Đã xảy ra sự cố. Vui lòng thử lại.',
      permission: 'Bạn không có quyền thực hiện hành động này.',
      disabled: 'Tác nhân theo lịch chưa được bật cho không gian làm việc này.',
      credits: 'Không gian làm việc không có đủ tín dụng.',
      limit: 'Không gian làm việc đã đạt giới hạn lịch đang hoạt động.',
      runPending: 'Lịch này đã có một lần chạy đang chờ hoặc đang thực thi.',
      invalidTime: 'Chọn một thời điểm hợp lệ trong tương lai.',
      notFound: 'Lịch hoặc lần chạy này không còn khả dụng.',
    },
  },
} satisfies Record<'vi', ScheduledDetailedCopy>;
